import React, { createContext, useCallback, useContext, useState } from "react";
import ReserveModal from "@/components/boost/ReserveModal";

const ReserveCtx = createContext({ open: () => {} });

export const ReserveProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openModal = useCallback(() => setOpen(true), []);
  return (
    <ReserveCtx.Provider value={{ open: openModal }}>
      {children}
      <ReserveModal open={open} onOpenChange={setOpen} />
    </ReserveCtx.Provider>
  );
};

export const useReserve = () => useContext(ReserveCtx);
